import { ROUTER_NAVIGATED, RouterRequestAction } from '@ngrx/router-store'
import { map } from 'rxjs/operators'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Router } from '@angular/router'
import { closeMegaMenus } from './menus.actions'

@Injectable()
export class RouterEffects {
    private actions$ = inject(Actions)
    private router = inject(Router)


    updateStoreOnRouteChange$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ROUTER_NAVIGATED),
            map((payload :  RouterRequestAction) => {
                return closeMegaMenus()
            }),
        )
    )
}